import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  Typography,
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import { ContentWrapper } from '../../shared/ContentWrapper/ContentWrapper';
import { retreiveShoppers } from '../../api/exclusiveShoppers';
import { assignShopperToOrder } from '../../api/shopperOrders';
import { getToken } from '../../services/auth';

export const AssignShopper = () => {
  const { reference, id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const orderType = queryParams.get('orderType');
  const storeId = useSelector((state) => state.store.id);
  const [shoppers, setShoppers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (storeId) {
      retreiveShoppers({ 
        id: storeId, 
        token: getToken(),
        params: orderType ? { orderType } : undefined
      })
        .then((res) => {
          const shoppersData = res && res.results ? res.results : (Array.isArray(res) ? res : []);
          setShoppers(shoppersData);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [storeId]);

  const handleAssign = async (shopperId) => {
    try {
      await assignShopperToOrder({
        reference,
        shopperId,
        token: getToken(),
      });
      alert('Shopper assigned successfully!');
      if (id) {
        navigate(`/shopper/order/${id}`);
      } else {
        navigate('/shopper/my-orders/');
      }
    } catch (err) {
      let msg = 'Error assigning shopper';
      if (err.response && err.response.data && err.response.data.detail) {
        msg = err.response.data.detail;
      } else if (err.response && err.response.status === 400) {
        msg = 'No se puede asignar al usuario que creó la orden.';
      }
      alert(msg);
    }
  };

  if (loading) {
    return (
      <ContentWrapper>
        <Box display="flex" justifyContent="center" mt={5}>
          <CircularProgress />
        </Box>
      </ContentWrapper>
    );
  }

  return (
    <ContentWrapper>
      <Box mb={3}>
        <Typography variant="h4">Assign Shopper to Order #{reference}</Typography>
      </Box>
      <Paper>
        <List>
          {shoppers.map((shopper) => (
            <ListItem key={shopper.id} button onClick={() => handleAssign(shopper.user?.id || shopper.id)}>
              <ListItemText
                primary={`${shopper.user?.firstName || shopper.user?.first_name || ''} ${shopper.user?.lastName || shopper.user?.last_name || ''}`.trim() || 'Unknown'}
                secondary={shopper.user?.email || shopper.email || ''}
              />
            </ListItem>
          ))}
          {shoppers.length === 0 && (
            <ListItem>
              <ListItemText primary="No exclusive shoppers found." />
            </ListItem>
          )}
        </List>
      </Paper>
    </ContentWrapper>
  );
};
